// import React, { useState } from "react";
// import axios from "axios";
// import { Download, X } from "lucide-react";
// import { BASE_URL } from "../../../services/configUrls";
// const STATUS_OPTIONS = [
//   { label: "Passed", value: "passed" },
//   { label: "Failed", value: "failed" },
//   { label: "Dropout", value: "dropout" },
// ];

// const FacultyExportPopover = ({ bookslotId }) => {
//    console.log("FacultyExportPopover mounted with bookslotId:", bookslotId);
//   const [open, setOpen] = useState(false);
//   const [selectedStatus, setSelectedStatus] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const toggleStatus = (value) => {
//     setSelectedStatus((prev) =>
//       prev.includes(value)
//         ? prev.filter((s) => s !== value)
//         : [...prev, value]
//     );
//   };

//   const downloadCSV = async () => {
//     console.log("downloadCSV called, selectedStatus:", selectedStatus);
//     if (!selectedStatus.length) {
//       alert("Please select at least one status");
//       return;
//     }

//     try {
//       setLoading(true);

//       const token = localStorage.getItem("accessToken");

//       const res = await axios.post(
//         `${BASE_URL}/event/fdp/faculty-export`,
//         {
//           bookslot_id: bookslotId,
//           status: selectedStatus,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       // 🔽 base64 → file
//       const { base64, filename } = res.data;
//       const byteCharacters = atob(base64);
//       const byteNumbers = Array.from(byteCharacters).map((c) =>
//         c.charCodeAt(0)
//       );
//       const blob = new Blob([new Uint8Array(byteNumbers)], {
//         type: "text/csv",
//       });

//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.download = filename;
//       link.click();
//       window.URL.revokeObjectURL(url);

//       setOpen(false);
//       setSelectedStatus([]);
//     } catch (err) {
//       console.error("CSV export error:", err);
//       alert(err.response?.data?.detail || "Failed to export CSV");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="relative inline-block">
//       {/* Trigger Button */}
//       <button
//         onClick={() => setOpen(!open)}
//         className="flex items-center gap-2 px-3 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700"
//       >
//         <Download size={16} />
//         Export CSV
//       </button>

//       {/* Popover */}
//       {open && (
//         <div className="absolute right-0 mt-2 w-64 bg-white border rounded-xl shadow-lg p-4 z-50">
//           <div className="flex justify-between items-center mb-3">
//             <h4 className="font-semibold text-gray-800">Select Status</h4>
//             <button onClick={() => setOpen(false)}>
//               <X size={16} />
//             </button>
//           </div>

//           <div className="space-y-2">
//             {STATUS_OPTIONS.map((s) => (
//               <label
//                 key={s.value}
//                 className="flex items-center gap-2 text-sm"
//               >
//                 <input
//                   type="checkbox"
//                   checked={selectedStatus.includes(s.value)}
//                   onChange={() => toggleStatus(s.value)}
//                 />
//                 {s.label}
//               </label>
//             ))}
//           </div>

//           <button
//             onClick={downloadCSV}
//             disabled={loading}
//             className="mt-4 w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 disabled:opacity-60"
//           >
//             {loading ? "Downloading..." : "Download CSV"}
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default FacultyExportPopover;

import React, { useState } from "react";
import axios from "axios";
import { Download, X } from "lucide-react";
import { BASE_URL } from "../../../services/configUrls";
const STATUS_OPTIONS = [
  { label: "Passed", value: "passed" },
  { label: "Failed", value: "failed" },
  { label: "Dropout", value: "dropout" },
  {label:"Participants",value:"participants"}
];

const FacultyExportPopover = ({ bookslotId }) => {
   console.log("FacultyExportPopover mounted with bookslotId:", bookslotId);
  const [open, setOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [loading, setLoading] = useState(false);

  const toggleStatus = (value) => {
    setSelectedStatus((prev) =>
      prev.includes(value)
        ? prev.filter((s) => s !== value)
        : [...prev, value]
    );
  };

  const downloadCSV = async () => {
    console.log("downloadCSV called, selectedStatus:", selectedStatus);
    if (!selectedStatus.length) {
      alert("Please select at least one status");
      return;
    }

    try {
      setLoading(true);

      const token = localStorage.getItem("accessToken");

      const res = await axios.post(
        `${BASE_URL}/event/fdp/faculty-export`,
        {
          bookslot_id: bookslotId,
          status: selectedStatus,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // 🔽 base64 → file
      const { base64, filename } = res.data;
      const byteCharacters = atob(base64);
      const byteNumbers = Array.from(byteCharacters).map((c) =>
        c.charCodeAt(0)
      );
      const blob = new Blob([new Uint8Array(byteNumbers)], {
        type: "text/csv",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(url);

      setOpen(false);
      setSelectedStatus([]);
    } catch (err) {
      console.error("CSV export error:", err);
      alert(err.response?.data?.detail || "Failed to export CSV");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative inline-block">
      {/* Trigger Button */}
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700"
      >
        <Download size={16} />
        Export CSV
      </button>

      {/* Popover */}
      {open && (
        <div className="absolute right-0 mt-2 w-64 bg-white border rounded-xl shadow-lg p-4 z-50">
          <div className="flex justify-between items-center mb-3">
            <h4 className="font-semibold text-gray-800">Select Status</h4>
            <button onClick={() => setOpen(false)}>
              <X size={16} />
            </button>
          </div>

          <div className="space-y-2">
            {STATUS_OPTIONS.map((s) => (
              <label
                key={s.value}
                className="flex items-center gap-2 text-sm"
              >
                <input
                  type="checkbox"
                  checked={selectedStatus.includes(s.value)}
                  onChange={() => toggleStatus(s.value)}
                />
                {s.label}
              </label>
            ))}
          </div>

          <button
            onClick={downloadCSV}
            disabled={loading}
            className="mt-4 w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 disabled:opacity-60"
          >
            {loading ? "Downloading..." : "Download CSV"}
          </button>
        </div>
      )}
    </div>
  );
};

export default FacultyExportPopover;
